import axios from 'axios';
import API_URL from './config';

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.response.use(
    (response) => {
        const token = response.headers['token'];
        if (token) {
            localStorage.setItem('token', token);
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
